import React, { useState, useEffect } from "react";
import Dropdown from "react-dropdown-select";
import { customSelectStyles2, alignedContentRenderer, paddedItemRenderer2 } from "../../../util_functions/helpers";
import timeSlotsData from "./../../fs-account/jobs-section/data/timeSlotsData.json";

const ToggleWithText = ({
  text,
  onUpdate,
  initialAvailability = [],
  reportValidation,
}) => {
  const [isToggled, setIsToggled] = useState(initialAvailability.length > 0);
  const [timeSlots, setTimeSlots] = useState([]);
  const [errors, setErrors] = useState({});

  const options = timeSlotsData.timeSlots.map((time) => ({
    label: time,
    value: time,
  }));

  useEffect(() => {
    setIsToggled(initialAvailability.length > 0);
    const initialTimeSlots = initialAvailability.map((slot, index) => ({
      ...slot,
      id: `initial-${index}-${Date.now() + Math.random()}`,
    }));
    setTimeSlots(initialTimeSlots);
  }, [initialAvailability]);

  useEffect(() => {
    validateTimeSlots();
  }, [timeSlots]);

  const toggleContainer = () => {
    const toggleStatus = !isToggled;
    setIsToggled(toggleStatus);
    if (!toggleStatus) {
      onUpdate(text, []);
    } else {
      if (timeSlots.length === 0) addTimeSlotField();
      else onUpdate(text, timeSlots);
    }
  };

  const addTimeSlotField = () => {
    const newTimeSlot = {
      from: "",
      to: "",
      id: `new-${Date.now() + Math.random()}`,
    };

    setTimeSlots((prevSlots) => {
      const updatedSlots = [...prevSlots, newTimeSlot];
      onUpdate(text, updatedSlots);
      return updatedSlots;
    });
  };

  const removeTimeSlotField = (id) => {
    setTimeSlots((prevSlots) => {
      const updatedSlots = prevSlots.filter((slot) => slot.id !== id);
      if (isToggled) {
        onUpdate(text, updatedSlots);
      }
      return updatedSlots;
    });
  };

  const handleDropdownChange = (id, type, selected) => {
    const value = selected.length > 0 ? selected[0].value : "";
    const updatedSlots = timeSlots.map((slot) =>
      slot.id === id ? { ...slot, [type]: value } : slot
    );
    setTimeSlots(updatedSlots);
    onUpdate(text, updatedSlots);
  };

  const toggleClass = isToggled ? "toggle-switch active" : "toggle-switch";

  const validateTimeSlots = () => {
    const newErrors = {};
    let allValid = true;

    timeSlots.forEach((slot) => {
      if (!slot.from || !slot.to) {
        newErrors[slot.id] = true;
        allValid = false;
      } else {
        newErrors[slot.id] = false;
      }
    });

    setErrors(newErrors);
    reportValidation(text, allValid);
    return allValid;
  };

  return (
    <div className="toggle-day-container">
      <div className="toggle-container" onClick={toggleContainer}>
        <div className={toggleClass}>
          <div className="toggle-circle"></div>
        </div>
        <span>{text}</span>
      </div>
      {isToggled &&
        timeSlots.map((slot, index) => (
          <div
            key={slot.id}
            className={`time-fields-container ${errors[slot.id] ? "toggle-error" : ""
              }`}
          >
            <div className="time-fields-wrapper">
              <div className="time-fields">
                <div className="time-select">
                  <label htmlFor={`${text}-from-${index}`}>From</label>
                  <Dropdown
                    options={options}
                    values={
                      slot.from
                        ? [{ label: slot.from, value: slot.from }]
                        : []
                    }
                    onChange={(selected) =>
                      handleDropdownChange(slot.id, "from", selected)
                    }
                    className={errors[slot.id] ? "toggle-error" : ""}
                    style={customSelectStyles2(false)}
                    contentRenderer={alignedContentRenderer}
                    itemRenderer={paddedItemRenderer2}
                  />
                </div>
                <div className="time-select">
                  <label htmlFor={`${text}-to-${index}`}>To</label>
                  <Dropdown
                    options={options}
                    values={
                      slot.to ? [{ label: slot.to, value: slot.to }] : []
                    }
                    onChange={(selected) =>
                      handleDropdownChange(slot.id, "to", selected)
                    }
                    className={errors[slot.id] ? "toggle-error" : ""}
                    style={customSelectStyles2(false)}
                    contentRenderer={alignedContentRenderer}
                    itemRenderer={paddedItemRenderer2}
                  />
                </div>
              </div>
              <div
                className="remove-text-action"
                onClick={() => removeTimeSlotField(slot.id)}
              >
                Remove
              </div>
            </div>
            {errors[slot.id] && (
              <div className="toggle-error-message">
                Please select both start and end times.
              </div>
            )}
          </div>
        ))}

      {isToggled && (
        <div className="add-text-action" onClick={addTimeSlotField}>
          + Add Time Slot
        </div>
      )}
    </div>
  );
};

export default ToggleWithText;
